import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { EASE } from "@/components/Reveal";

export const WHATSAPP_URL =
  "https://wa.me/6592366649?text=Hi%20Cosmic%20Division%2C%20I%27d%20like%20to%20make%20an%20enquiry.";
export const PHONE_DISPLAY = "+65 9236 6649";
export const PHONE_TEL = "tel:+6592366649";
export const EMAIL = "pedro.lim@cosmic-div.com";
export const ADDRESS = "8A Admiralty St, FoodXchange #02-26, Singapore 757437";
export const CAROUSELL_URL =
  "https://www.carousell.sg/p/professional-accounting-bookkeeping-services-gst-payroll-tax-company-loyal-support-1401991798/";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CW1pLXdVdI3_EBM/review";
export const GOOGLE_PROFILE_URL =
  "https://www.google.com/maps/search/?api=1&query=Cosmic+Division+Pte+Ltd+8A+Admiralty+St+Singapore+757437";

const Navbar = () => (
  <motion.header
    data-testid="navbar"
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: EASE }}
    className="sticky top-0 z-50 border-b border-charcoal/10 bg-cream/90 backdrop-blur-md"
  >
    <div className="mx-auto flex h-16 w-full max-w-[1700px] items-center justify-between px-5 md:h-[76px] md:px-10">
      <button
        type="button"
        onClick={() =>
          window.__lenis
            ? window.__lenis.scrollTo(0)
            : window.scrollTo({ top: 0, behavior: "smooth" })
        }
        data-testid="nav-logo-link"
        className="flex items-center gap-3 text-left"
      >
        <img
          src="/assets/logo-mark.png"
          alt="Cosmic Division Pte Ltd logo"
          className="h-10 w-10 object-contain"
        />
        <span className="leading-none">
          <span className="block font-body text-[17px] font-bold tracking-tight text-charcoal">
            COSMIC
          </span>
          <span className="mt-1 block text-[9px] font-medium uppercase tracking-[0.28em] text-charcoal/50">
            Division Pte Ltd
          </span>
        </span>
      </button>

      <div className="flex items-center gap-6">
        <span className="hidden items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-charcoal/50 lg:flex">
          <span className="h-1.5 w-1.5 rounded-full bg-jade" aria-hidden="true" />
          Your Partner in Singapore
        </span>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-button"
          className="group inline-flex items-center gap-2.5 rounded-full border border-charcoal/15 bg-white px-4 py-2.5 text-sm font-medium text-charcoal transition-colors duration-300 hover:border-forest/40 md:px-5"
        >
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#25D366]">
            <MessageCircle className="h-3.5 w-3.5 text-white" fill="currentColor" />
          </span>
          Let&apos;s talk
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </div>
  </motion.header>
);

export default Navbar;
